/* eslint-disable react-hooks/exhaustive-deps */
import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * Este hook se comporta igual que useEffect, con la diferencia de que en el
 * primer renderizado no se va a ejecutar.
 */
export function useUpdateEffect(effect: EffectCallback, deps?: DependencyList) {
  const hasRunnedForFirstTime = useRef(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (hasRunnedForFirstTime.current) {
      return effect();
    }
    hasRunnedForFirstTime.current = true;
    return () => {};
  }, deps);
}
